import { message } from 'components/common'

export const showMessage = (
  type: 'success' | 'error',
  content: string | JSX.Element
) => {
  message[type]({ content, duration: 4 })
}
